module.exports = __webpack_public_path__ + "static/img/icon3_1.e593541.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon3_1.png
// module id = ka2c
// module chunks = 120